import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const arjSettingsDependenciesRoute: InvariantJiraRoute = {
	name: 'arj-settings-dependencies',
	path: '/jira/plans/settings/dependencies',
};
